import { render, staticRenderFns } from "./dataCollection.vue?vue&type=template&id=151e7db0&"
import script from "./dataCollection.vue?vue&type=script&lang=js&"
export * from "./dataCollection.vue?vue&type=script&lang=js&"
import style0 from "./dataCollection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports